import React, { Fragment, useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import Chart from "react-apexcharts";
import { Row, Col, Nav, Tab, Dropdown } from "react-bootstrap";
import Card from "../../Card";
import { FaTimes, FaEllipsisV, FaEdit, FaTrash } from "react-icons/fa";
import { FiMoreVertical, FiPlus, FiCalendar, FiUser, } from "react-icons/fi";
 import MasterTable2 from "../../../views/dashboard/widget/MasterTabe2";
 import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddRoomFacilityComponent from "./add-room-facility-component";
import { getRoomFacilitiesList, deleteRoomFacility } from "../../../services/OrganisationServices/hostelRoomServices";
import RoomFacilitiesTable from "./room-facilities-table";
import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";
import HostelUsersTable from "./hostel-users-table";
import { useParams, useNavigate } from "react-router-dom";
import { getRoomDetails } from "../../../services/OrganisationServices/hostelRoomServices";
import RoomUsersTable from "./room-users-table";
import {
  callToast,
  showErrorMessages,
  getMethods
} from "../../../services/utilityFunctions";

const RoomDetailPage = () => {
  const [sharedState, setSharedState] = useSharedState();
  var { roomId, id } = useParams();
  const [modifiedBy, setModifiedBy] = useState("loading...");
  const navigate = useNavigate();
  const { hostelMenuState, toggleHostelMenu } = useGlobalState();
  const [hostelDetails, setHostelDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createdBy, setCreatedBy] = useState("loading...");
  const [createdOn, setCreatedOn] = useState("loading...");

  // console.log("sssssssss roomId is ", roomId);
 


  useEffect(() => {
    setSharedState(true);
    toggleHostelMenu(true);

    const fetchRoomDetails = async () => {
      setLoading(true);
      const response = await getRoomDetails(roomId);

      if (response.status === "success") {
        console.log("response.data", response.data);
        setCreatedBy(response.data["CREATED BY"]);
        setCreatedOn(response.data["CREATED ON"]);
        setModifiedBy(response.data["MODIFIED BY"]);
        setHostelDetails(response.data);
      } else if (response.status === "fail") {
        showErrorMessages({ data: response, navigate });
      }
      setLoading(false);
    };

    if (roomId) {
      fetchRoomDetails();
    }
  }, [roomId]);

  return (
    <Fragment>
       
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col lg="12">
          <Card>
            <Card.Body>
              <div className="row g-3">
                <div className="col-9">
                  <div className="mb-4">
                    <h4 className="me-2 h4 mb-0">
                      {loading ? "Loading..." : hostelDetails?.["ROOM NUMBER"] || "Room Details"}
                    </h4>
                  </div>
                  <div style={{ marginBottom: "6rem" }}></div>
                  <div className="mt-4">
                    <Nav
                      as="ul"
                      className="nav-tabs mb-0 text-center profile-tab"
                      data-toggle="slider-tab"
                      id="profile-pills-tab"
                      role="tablist"
                    >
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link eventKey="first">Users</Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link eventKey="second">Facilities</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                </div>

                <div className="col-3">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                      <div
                        className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                        style={{ width: 28, height: 28 }}
                      >
                        <FiUser className="text-primary fs-6" />
                      </div>
                      <div>
                        <small className="text-muted d-block">Created By</small>
                        <div
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {createdBy}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                      <div
                        className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                        style={{ width: 28, height: 28 }}
                      >
                        <FiCalendar className="text-success fs-6" />
                      </div>
                      <div>
                        <small className="text-muted d-block">Created On</small>
                        <div
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {createdOn}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                      <div
                        className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                        style={{ width: 28, height: 28 }}
                      >
                        <FiCalendar className="text-success fs-6" />
                      </div>
                      <div>
                        <small className="text-muted d-block">Modified By</small>
                        <div
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {modifiedBy}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-friends">
                <RoomUsersTable hostelId={id} roomId={roomId} />
              </Tab.Pane>

              <Tab.Pane eventKey="second" id="profile-friends">
          <MasterTable2
            getList={getRoomFacilitiesList}
            tab1={"Hostel"}
            tab2={"Room Facilities"}
            hostelId={id}
            roomId={roomId}
            AddForm={AddRoomFacilityComponent}
            actions={{
              delete: true,
            }}
            deleteFun={deleteRoomFacility}
            
            title={"Room Facilities"}
            subTitle={"Facility"}
            // refresh={() => fetchList({ hostelId: id, roomId: roomId })}
            details={hostelDetails || {}}  
            isAdmin={true}  
          />
        </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Fragment>
  );
};

export default RoomDetailPage;
